export const QUICK_SLIDE_MOTION: {
	stiffness: number;
	damping: number;
	precision: number;
} = {
	stiffness: 640,
	damping: 37,
	precision: 1,
};
